<template>
    <div class="mb-8 space-y-2 max-w-7xl mx-auto">
        <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
            <h4 class="text-lg text-center font-medium">
                {{ $t('Users who want to send giv') }}
            </h4>
        </div>
        <form class="py-2 px-4 grid grid-cols-3">
            <div class="flex items-center space-x-3">
                <span class="text-sm font-medium">Filter by Status</span>
                <a-select
                    :disabled="loading"
                    v-model="filterStatus"
                    style="width: 140px"
                    @change="handleChange"
                >
                    <a-select-option value="all">
                        All
                    </a-select-option>
                    <a-select-option value="pending">
                        Pending
                    </a-select-option>
                    <a-select-option value="match">
                        Match
                    </a-select-option>
                    <a-select-option value="match-no-giv">
                        Match (No Giv)
                    </a-select-option>
                </a-select>
            </div>
            <div class="flex items-center space-x-3">
                <span class="text-sm font-medium">Sort</span>
                <a-select
                    :disabled="loading"
                    v-model="sort"
                    style="width: 120px"
                    @change="handleChange"
                >
                    <a-select-option value="createdAt">
                        Register Date
                    </a-select-option>
                    <a-select-option value="updatedAt">
                        Update Date
                    </a-select-option>
                </a-select>
            </div>
            <div>
                <label for="name" class="hidden">{{ $t('Search') }}</label>
                <v-select
                    class="flex-1 style-select"
                    @search="search"
                    placeholder="Filter by member"
                    :options="filterMemberList"
                    @input="setSelected"
                    clearable
                >
                    <template v-slot:option="option">
                        <div
                            class="w-full py-3 flex items-center space-x-3 focus:outline-none overflow-x-hidden"
                        >
                            <div
                                class="flex-shrink-0 w-12 sm:w-20 h-12 sm:h-20 rounded border-2 border-gray-200 overflow-hidden"
                            >
                                <img
                                    loading="lazy"
                                    alt="option.name"
                                    width="100%"
                                    height="100%"
                                    class="object-cover"
                                    :src="parseUrl(option.photoURL)"
                                />
                            </div>
                            <div class="flex-1 truncate">
                                <div class="flex items-center space-x-4">
                                    <h3 class="text-sm sm:text-lg font-medium ml-2">
                                        {{ option.name }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </form>
        <ul class="space-y-1">
            <li v-for="req in givRequests" :key="req.id">
                <GivRequestCard :req="req" />
            </li>
        </ul>
        <spinner v-if="loading" />
        <div v-else>
            <div v-if="hasMore" class="flex justify-center">
                <button
                    @click="showMore"
                    class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                >
                    <spinner v-if="loadingMore" class="text-white" />
                    <span v-else>{{ $t('Load More') }}</span>
                </button>
            </div>
            <div v-else class="flex justify-center">
                <span>{{ $t('No more items to show') }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import api from '../lib/api'
import GivRequestCard from '../components/GivRequestCard'
export default {
    components: {
        GivRequestCard,
    },
    data() {
        return {
            filterStatus: 'all',
            sort: 'createdAt',
            givRequests: [],
            loading: true,
            searching: false,
            loadingMore: false,
            limit: 20,
            offset: 0,
            hasMore: true,
            filterMemberList: [],
            filteredMember: null,
        }
    },
    async mounted() {
        if (this.$route.query.reload === true) {
            this.$router.push('/want-sends')
        }
        this.searchRequests()
    },
    methods: {
        search: _.debounce(async function(search, loading) {
            if (!search || search === '') return
            loading(true)
            const result = await api.searchUsersByName(search)
            const makeList = list => {
                return list.map(item => {
                    return {
                        ...item,
                        label: item.name,
                        id: item.id,
                    }
                })
            }
            this.filterMemberList = makeList(result)
            loading(false)
        }, 500),
        async setSelected(value) {
            this.filteredMember = value
            this.searchRequests()
        },

        async searchRequests() {
            this.loading = true
            const status = this.filterStatus === 'all' ? null : this.filterStatus
            const [givRequests, newOffset] = await api.getGivRequests(
                'send',
                this.limit,
                null,
                status,
                this.filteredMember?.id,
                this.sort,
            )
            this.givRequests = givRequests
            this.offset = newOffset
            this.loading = false
        },
        handleChange() {
            this.searchRequests()
        },
        dedupeItems(items = []) {
            const dedupeMap = {}
            items.forEach(i => {
                dedupeMap[i.id] = i
            })
            return Object.values(dedupeMap)
        },
        async showMore() {
            this.loadingMore = true
            const status = this.filterStatus === 'all' ? null : this.filterStatus
            const [moreRequests, newOffset] = await api.getGivRequests(
                'send',
                this.limit,
                this.offset,
                status,
                this.filteredMember?.id,
                this.sort,
            )
            this.givRequests = this.dedupeItems([...this.givRequests, ...moreRequests])
            this.offset = newOffset
            this.loadingMore = false
        },
        parseUrl(url) {
            if (!url) return url
            if (url.startsWith('http')) {
                return url
            }
            return `https://cdn.giv.link/${url}`
        },
    },
}
</script>
